export default __webpack_public_path__ + "images/8f3a7ae2fc955aaa45d03e5fa230b628-homepage_pride_659x494.webp";